import { Component, OnInit } from '@angular/core';
import { ShoppingService } from "../../shared/services/shopping.service";

@Component({
  selector: 'app-checkout-status-monitor',
  templateUrl: './checkout-status-monitor.component.html',
  styleUrls: ['./checkout-status-monitor.component.css']
})
export class CheckoutStatusMonitorComponent implements OnInit {

    private orderStatus:string
  constructor(
    private shopping:ShoppingService
  ) { }

  ngOnInit() {
    this.shopping.getCheckoutStatus().subscribe((status:string) => {
      this.orderStatus = status;
    });
  }

  get orderStart() {
    return this.orderStatus === "ORDER_START";
  }

  get paymentPrepare() {
    return this.orderStatus === "PAYMENT_PREPARE";
  }

  get orderFinalize() {
    return this.orderStatus === "ORDER_FINALIZE";
  }

  get orderComplete() {
    return this.orderStatus === "ORDER_COMPLETE";
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/checkout-status-monitor/checkout-status-monitor.component.ts